import React, { useState } from 'react';
import {
  IconButton,
  TableCell,
  TableRow,
  Tooltip,
  Icon
} from '@material-ui/core';
import { format, parse } from 'date-fns';
import { convertUTCDateToLocalDate } from 'helpers/date';
import RequestedPromotionDetails from './RequestedPromotionDetails';


const formatDate = (dateString, timeString) => {
  const date = dateString;
  const time = timeString ? parse(timeString, 'hh:mm aa', new Date()) : date;
  const formattedDate = new Date(date.setHours(time.getHours(), time.getMinutes(), time.getSeconds()));

  return (
    <>
      <div>{format(formattedDate, 'MM/dd/yyyy')}</div>
      <div>{format(formattedDate, 'hh:mm:ss aa')}</div>
    </>
  );
};

const RequestedPromotionTableRow = ({ promotionData, headTableCells }) => {
  const [open, setOpen] = useState(false);
  const [selectedPromotion, setSelectedPromotion] = useState(null);

  const {
    userId: {
      firstName,
      lastName,
      email
    },
    data: {
      title,
      discountType: {
        name: discountName
      },
      dates: {
        startDate,
        startTime,
        endDate,
        endTime
      }
    },
    createdAt
  } = promotionData;

  const columns = headTableCells.reduce((acc, column) => {
    acc[column.label] = column;
    return acc;
  }, {});

  const formattedCreatedDate = createdAt ? convertUTCDateToLocalDate(createdAt) : '';
  const formattedStartDate = startDate ? convertUTCDateToLocalDate(startDate) : '';
  const formattedEndDate = endDate ? convertUTCDateToLocalDate(endDate) : '';

  const handleClickOpen = (promotion) => {
    setSelectedPromotion(promotion);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedPromotion(null);
  };

  return (
    <>
      <TableRow>
        {columns['Requested by']?.display && <TableCell align="center">{firstName} {lastName}</TableCell>}
        {columns['Email']?.display && <TableCell className="whitespace-no-wrap" align="center">{email}</TableCell>}

        {columns['Created Date']?.display &&
          <TableCell align="center">
            {formattedCreatedDate && formatDate(formattedCreatedDate, '')}
          </TableCell>
        }
        {columns['Title']?.display && <TableCell className="whitespace-no-wrap" align="center">{title}</TableCell>}
        {columns['Discount Type']?.display && <TableCell align="center">{discountName}</TableCell>}

        {columns['Start Date']?.display &&
          <TableCell align="center">
            {formattedStartDate && formatDate(formattedStartDate, startTime)}
          </TableCell>
        }

        {columns['End Date']?.display &&
          <TableCell align="center">
            {formattedEndDate && formatDate(formattedEndDate, endTime)}
          </TableCell>
        }

        {columns['Details']?.display &&
          <TableCell align="center">
            <Tooltip title="Details">
              <IconButton
                onClick={() => handleClickOpen(promotionData)}
              >
                <Icon>visibility</Icon>
              </IconButton>
            </Tooltip>
          </TableCell>
        }
      </TableRow>

      {selectedPromotion && (
        <RequestedPromotionDetails
          handleClose={handleClose}
          open={open}
          selectedPromotion={promotionData?.data}
        />
      )}
    </>
  );
};

export default RequestedPromotionTableRow;
